import { Component, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { SearchFilterService } from '../Services/search-filter.service';
import { NewsArticles, SearchStaticContent } from '../Models/common.model';
import { paginate } from '../Models/common.pagination';
import { LocationStrategy } from '@angular/common';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styles: [],
    providers: [SearchFilterService]
})
export class SearchComponent {
    page = 1;
    pageSize = 10; //No of pages per page
    maxPages = 10;
    startIndex: number;
    endIndex: number;
    pageOfItems: Array<any>;
    pager: any = {};
    filterbyValues: any[];
    noSearchText: string;
    loadingText: boolean;

    private _staticContent: SearchStaticContent;
    get staticContent(): SearchStaticContent {
        return this._staticContent;
    }
    set staticContent(value: SearchStaticContent) {
        this._staticContent = value;
    }

    private _newsArticles: NewsArticles[];
    get newsArticles(): NewsArticles[] {
        return this._newsArticles;
    }
    set newsArticles(value: NewsArticles[]) {
        this._newsArticles = value;
        this.setPage(this.newsArticles);
    }

    cacheFilterNewsarticles: NewsArticles[] = [];

    filteredArticles: NewsArticles[] = [];
    searchedArticles: NewsArticles[] = [];

    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
        sessionStorage.setItem('searchText', this.searchText);
        this.performSearch(this.searchText);
    }

    @ViewChild('txtSearch') searchInput: ElementRef;
    @ViewChild('dnFilterText') filterDropdown: ElementRef;

    constructor(public dataService: SearchFilterService, public location: LocationStrategy) {
        if ((window.performance.getEntries()[0] as any).type == 'reload' || (window.performance.getEntries()[0] as any).type  == 'navigate') {
            sessionStorage.clear();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    ngOnInit(): void {
        this.loadingText = true;
        if (sessionStorage.length > 0) {
            this.page = !isNaN(parseInt(sessionStorage.getItem('pageIndex'))) ? parseInt(sessionStorage.getItem('pageIndex')) : 1;
            
        }
        this.dataService.getPagetitleErrormsg().subscribe((data: SearchStaticContent) => {
            this.staticContent = data;
            this.pageSize = data.PageSize;
        })

            this.dataService.getNewsArticles().subscribe((data: NewsArticles[]) => {
                this.newsArticles = data;
                this.cacheFilterNewsarticles = data;
                this.loadingText = false;
                if (sessionStorage.getItem('searchText') != '' && sessionStorage.getItem('searchText') != undefined) {
                    this.searchText = sessionStorage.getItem('searchText');
                }

                if (sessionStorage.getItem('filterIndex') != undefined && sessionStorage.getItem('filterIndex') != null) {
                    var selectedIndex = sessionStorage.getItem('filterIndex');
                    this.loadingText = false;
                    if (this.filterDropdown != undefined) {
                        this.filterDropdown.nativeElement.options[selectedIndex].selected = true;
                    }
                }
            })

        this.dataService.getfilterby().subscribe((data: any[]) => {
            this.filterbyValues = data;
        })

      
    }

    performSearch(filterby?: any) {
        if (filterby) {
            if (this.filteredArticles.length > 1) {
                this.newsArticles = this.filteredArticles.filter((newsArticles: NewsArticles) => {
                    return this.getfilteredValues(newsArticles, filterby);
                });
                this.searchedArticles = this.newsArticles;
            }
            else {
                this.newsArticles = this.cacheFilterNewsarticles.filter((newsArticles: NewsArticles) => {
                    return this.getfilteredValues(newsArticles, filterby);
                });
                this.searchedArticles = this.newsArticles;
            }
        }
        else {
            if (this.filteredArticles.length > 1) {
                this.newsArticles = this.filteredArticles;
                this.searchedArticles = this.newsArticles;
            }
            else {
                this.newsArticles = this.cacheFilterNewsarticles;
                this.searchedArticles = this.cacheFilterNewsarticles;
            }
        }
        this.loadingText = false;
        this.setNosearchMessage(this.searchedArticles);
    }

    onChangePage(pageOfItems: any) {
        // update current page of items and set the number of items on page change
        sessionStorage.setItem('pageIndex', pageOfItems)
        this.pageOfItems = pageOfItems;
        this.setPage(this.newsArticles);
    }

    onFilterChange(filterby: any) {
        let selectedOptions = event.target['options'];
        let selectedIndex = selectedOptions.selectedIndex;
        let selectElementText = selectedOptions[selectedIndex].text;
        this.searchInput.nativeElement.value = "";//clear the search input value.
        sessionStorage.setItem('filterIndex', selectedIndex);
        if (selectedIndex == "0") {
            this.newsArticles = this.cacheFilterNewsarticles;
            this.filteredArticles = this.cacheFilterNewsarticles;
        }
        else {
            this.newsArticles = this.cacheFilterNewsarticles.filter(
                (newsArticles: NewsArticles) => {
                    return this.getfilteredValues(newsArticles, selectElementText);
                }
            )
            this.filteredArticles = this.newsArticles;
        }
        this.setNosearchMessage(this.filteredArticles);
    }

    setPage(article: NewsArticles[]) {
        this.pager = paginate(article.length, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }

    getfilteredValues(article: NewsArticles, searchTerm: string): boolean {

        return ((article.NewsTitle != null ? article.NewsTitle.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false) ||
            (article.NewsSummary != null ? article.NewsSummary.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false) ||
            (article.NewsBody != null ? article.NewsBody.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false)) ||
            (article.Tags != null ? article.Tags.map(function (t) { return t.toLowerCase(); }).indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false);
    }

    setNosearchMessage(article: NewsArticles[]) {
        if (article == undefined || article.length == 0) {
            this.dataService.getPagetitleErrormsg().subscribe((data: SearchStaticContent) => {
                this.staticContent = data;

            })
            let message = this.staticContent?.NoResultText;
            this.noSearchText = message;
        }
        else {
            this.noSearchText = null;
        }
    }
}
